var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartyConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8992 19.1003C14.212 20.413 15.7317 21.4113 17.1241 21.8754C18.5165 22.3395 19.6675 22.2315 20.3238 21.5751C20.9802 20.9188 21.0882 19.7678 20.6241 18.3754C20.16 16.983 19.1617 15.4633 17.849 14.1505C16.5362 12.8378 15.0165 11.8395 13.6241 11.3754C12.2317 10.9113 11.0807 11.0193 10.4243 11.6756C9.76796 12.332 9.65995 13.483 10.1241 14.8754C10.5882 16.2678 11.5865 17.7875 12.8992 19.1003V19.1003Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8668 12.9336L1.18414 28.1616C1.01237 28.5331 0.958731 28.9484 1.03047 29.3514C1.10221 29.7544 1.29587 30.1257 1.5853 30.4151C1.87473 30.7045 2.246 30.8982 2.64899 30.9699C3.05197 31.0417 3.46727 30.988 3.8388 30.8163L19.0668 22.1403",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0309 10.2664C21.0774 10.3128 21.1144 10.368 21.1396 10.4287C21.1648 10.4895 21.1778 10.5546 21.1778 10.6204C21.1778 10.6861 21.1648 10.7512 21.1396 10.812C21.1144 10.8727 21.0774 10.9279 21.0309 10.9744",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.324 10.2663C20.4177 10.1727 20.5448 10.1201 20.6773 10.1201C20.8098 10.1201 20.9369 10.1727 21.0306 10.2663",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3243 10.9691C20.2309 10.875 20.1785 10.7477 20.1785 10.6151C20.1785 10.4825 20.2309 10.3553 20.3243 10.2611",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0306 10.969C20.9369 11.0626 20.8098 11.1152 20.6773 11.1152C20.5448 11.1152 20.4177 11.0626 20.324 10.969",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6881 4.60522C26.7346 4.65156 26.7715 4.70662 26.7967 4.76725C26.8219 4.82789 26.8349 4.8929 26.8349 4.95856C26.8349 5.02422 26.8219 5.08923 26.7967 5.14986C26.7715 5.2105 26.7346 5.26556 26.6881 5.31189",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9816 4.60552C26.0279 4.559 26.083 4.52208 26.1436 4.4969C26.2042 4.47171 26.2692 4.45874 26.3349 4.45874C26.4006 4.45874 26.4656 4.47171 26.5262 4.4969C26.5868 4.52208 26.6419 4.559 26.6882 4.60552",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9815 5.31189C25.935 5.26556 25.8981 5.2105 25.8729 5.14986C25.8477 5.08923 25.8347 5.02422 25.8347 4.95856C25.8347 4.8929 25.8477 4.82789 25.8729 4.76725C25.8981 4.70662 25.935 4.65156 25.9815 4.60522",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6882 5.31177C26.5945 5.4054 26.4674 5.45799 26.3349 5.45799C26.2024 5.45799 26.0753 5.4054 25.9816 5.31177",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6881 18.7467C26.7347 18.7931 26.7716 18.8483 26.7968 18.9091C26.822 18.9698 26.835 19.0349 26.835 19.1007C26.835 19.1665 26.822 19.2316 26.7968 19.2923C26.7716 19.3531 26.7347 19.4083 26.6881 19.4547",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9816 18.7467C26.0753 18.6531 26.2024 18.6005 26.3349 18.6005C26.4674 18.6005 26.5945 18.6531 26.6882 18.7467",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9815 19.4547C25.9349 19.4083 25.898 19.3531 25.8728 19.2923C25.8476 19.2316 25.8346 19.1665 25.8346 19.1007C25.8346 19.0349 25.8476 18.9698 25.8728 18.9091C25.898 18.8483 25.9349 18.7931 25.9815 18.7467",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6882 19.4546C26.5945 19.5482 26.4674 19.6008 26.3349 19.6008C26.2024 19.6008 26.0753 19.5482 25.9816 19.4546",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1322 6.01843C11.2256 6.11258 11.278 6.23982 11.278 6.37243C11.278 6.50504 11.2256 6.63228 11.1322 6.72643",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4253 6.0183C10.519 5.92466 10.6461 5.87207 10.7786 5.87207C10.9111 5.87207 11.0382 5.92466 11.132 6.0183",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4256 6.72643C10.379 6.67999 10.3421 6.62481 10.3169 6.56407C10.2917 6.50332 10.2787 6.4382 10.2787 6.37243C10.2787 6.30667 10.2917 6.24154 10.3169 6.1808C10.3421 6.12005 10.379 6.06488 10.4256 6.01843",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.132 6.72705C11.0382 6.82069 10.9111 6.87328 10.7786 6.87328C10.6461 6.87328 10.519 6.82069 10.4253 6.72705",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 1C17.4244 3.51989 17.1834 6.07075 16.4349 8.49333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0922 2.83752L21.3855 6.37219",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0003 14.8574C28.4804 14.576 25.9295 14.817 23.507 15.5654",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.163 9.90784L25.6283 10.6145",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyConfetti);
export default __webpack_public_path__ + "static/media/PartyConfetti.e56eb3b9a4908bbaea3fa85e0969495b.svg";
export { ForwardRef as ReactComponent };